import React from "react";
import { NavLink } from "react-router-dom";
import "../css/Menu.css";

import packageJson from '../../package.json';

import { ReactComponent as IconInicio } from '../assets/icon/inicio.svg';
import { ReactComponent as IconUsuarios } from '../assets/icon/usuario.svg';
import { ReactComponent as IconEmpresas } from '../assets/icon/empresa.svg';
import { ReactComponent as IconEventos } from '../assets/icon/eventos.svg';
import { ReactComponent as IconTarjetas } from '../assets/icon/tarjetas.svg';
import { ReactComponent as IconPromociones } from '../assets/icon/promociones.svg';
import { ReactComponent as IconNotificaciones } from '../assets/icon/notificaciones.svg';
import { ReactComponent as IconCupones } from '../assets/icon/cupon.svg';
import { ReactComponent as IconClientes } from '../assets/icon/usuario.svg';

import { ReactComponent as IconInicioActivo } from '../assets/icon/inicioactivo.svg';
import { ReactComponent as IconUsuariosActivo } from '../assets/icon/usuarioactivo.svg';
import { ReactComponent as IconClientesActivo } from '../assets/icon/usuarioactivo.svg';
import { ReactComponent as IconEmpresasActivo } from '../assets/icon/empresaactivo.svg';
import { ReactComponent as IconEventosActivo } from '../assets/icon/eventosactivo.svg';
import { ReactComponent as IconTarjetasActivo } from '../assets/icon/tarjetasactivo.svg';
import { ReactComponent as IconPromocionesActivo } from '../assets/icon/promocionesactivo.svg';
import { ReactComponent as IconCuponesActivo } from '../assets/icon/cuponactivo.svg';


function Menu() {
  return (
    <div className="menucuerpo">

      <nav className="menu">
        {/* INICIO */}
        <NavLink
          to="/dashboard/inicio" className={({ isActive }) => (isActive ? "activo" : "")}>
          {({ isActive }) => (
            <>
              {isActive ? (
                <IconInicioActivo className="logo-svginicio" />
              ) : (
                <IconInicio className="logo-svginicio" />
              )}
              <span className="menu-text">Inicio</span>
            </>
          )}
        </NavLink>
        {/* Usuarios */}
        <NavLink
          to="/dashboard/usuarios" className={({ isActive }) => (isActive ? "activo" : "")}>
          {({ isActive }) => (
            <>
              {isActive ? (
                <IconUsuariosActivo className="logo-svginicio" />
              ) : (
                <IconUsuarios className="logo-svginicio" />
              )}
              <span className="menu-text">Usuarios</span>
            </>
          )}
        </NavLink>
        {/* Clientes */}
        <NavLink
          to="/dashboard/clientes" className={({ isActive }) => (isActive ? "activo" : "")}>
          {({ isActive }) => (
            <>
              {isActive ? (
                <IconClientesActivo className="logo-svginicio" />
              ) : (
                <IconClientes className="logo-svginicio" />
              )}
              <span className="menu-text">Clientes</span>
            </>
          )}
        </NavLink>
        {/* Empresas */}
        <NavLink
          to="/dashboard/empresas" className={({ isActive }) => (isActive ? "activo" : "")}>
          {({ isActive }) => (
            <>
              {isActive ? (
                <IconEmpresasActivo className="logo-svginicio" />
              ) : (
                <IconEmpresas className="logo-svginicio" />
              )}
              <span className="menu-text">Empresas</span>
            </>
          )}
        </NavLink>
        {/* Eventos */}

        <NavLink
          to="/dashboard/eventos" className={({ isActive }) => (isActive ? "activo" : "")}>
          {({ isActive }) => (
            <>
              {isActive ? (
                <IconEventosActivo className="logo-svginicio" />
              ) : (
                <IconEventos className="logo-svginicio" />
              )}
              <span className="menu-text">Eventos</span>
            </>
          )}
        </NavLink>
        {/* Cupones */}
        <NavLink
          to="/dashboard/cupones" className={({ isActive }) => (isActive ? "activo" : "")}>
          {({ isActive }) => (
            <>
              {isActive ? (
                <IconCuponesActivo className="logo-svginicio" />
              ) : (
                <IconCupones className="logo-svginicio" />
              )}
              <span className="menu-text">Cupones</span>
            </>
          )}
        </NavLink>
        {/* Tarjetas */}
        <NavLink
          to="/dashboard/tarjetas" className={({ isActive }) => (isActive ? "activo" : "")}>
          {({ isActive }) => (
            <>
              {isActive ? (
                <IconTarjetasActivo className="logo-svginicio" />
              ) : (
                <IconTarjetas className="logo-svginicio" />
              )}
              <span className="menu-text">Tarjetas</span>
            </>
          )}
        </NavLink>
        {/* Promociones */}
        <NavLink
          to="/dashboard/promociones" className={({ isActive }) => (isActive ? "activo" : "")}>
          {({ isActive }) => (
            <>
              {isActive ? (
                <IconPromocionesActivo className="logo-svginicio" />
              ) : (
                <IconPromociones className="logo-svginicio" />
              )}
              <span className="menu-text">Promociones</span>
            </>
          )}
        </NavLink>
      </nav>
      <div className="menu-version">v{packageJson.version}</div>
    </div>
  );
}

export default Menu;
